export const getEmbedCode = (beraterID) => {
	const WIDGET_URL = process.env.REACT_APP_WIDGET_URL
	return `<script src="${WIDGET_URL}"></script>
      <div class="five-digital-berater-widget" data-berater="${beraterID}">
      </div>`
}